import { useCallback, useState } from 'react';

/** Values being saved per row id, shown right away until the save settles. */
const usePendingValues = <T>() => {
  const [values, setValues] = useState<Record<string, T>>({});

  const start = useCallback((id: string, value: T) => {
    setValues((prev) => ({ ...prev, [id]: value }));
  }, []);

  const finish = useCallback((id: string) => {
    setValues((prev) => Object.fromEntries(Object.entries(prev).filter(([pendingId]) => pendingId !== id)));
  }, []);

  return { values, start, finish };
};

export default usePendingValues;
